import { AnyAction } from '@reduxjs/toolkit'
import { sortBy } from 'lodash'

import * as actionTypes from './actionTypes'

export type QuestionSet = {
  id?: any
  questions: string[]
  answers: QuestionSetAnswer[]
  topic: string
  status?: string
  displayStatus?: string
  lastUpdatedDate?: unknown
  savedSessionDraft?: unknown
  category?: string
  subtopic?: unknown
  isCustom?: unknown
  author?: unknown
  created_date?: any
  createdBy?: string
  modified_date?: any
  modifiedBy?: string
}
type QuestionSetAnswer = {
  answer: { response: { body: string } }
  scimAudience: any[]
  audience?: { all: string }[]
  selectedAudienceType?: string
  selectedAudienceValue?: string
}

type SpaceChatbotKnowledgeHubPageState = {
  questionSets: QuestionSet[]
  previousPath: string
  pendingQuestionSets: unknown[]
  questionSet: QuestionSet
  questionSetsToPublish?: QuestionSet[]
  createdQuestionSet?: QuestionSet
}

export const initialState: SpaceChatbotKnowledgeHubPageState = {
  questionSets: [],
  previousPath: 'summary',
  pendingQuestionSets: [],
  questionSet: {
    questions: [],
    answers: [
      {
        answer: { response: { body: '' } },
        scimAudience: []
      }
    ],
    topic: ''
  }
}

export default function knowledgeReducer(state = initialState, action: AnyAction): SpaceChatbotKnowledgeHubPageState {
  let questionSets: QuestionSet[] = []
  switch (action.type) {
    case actionTypes.RESET_QUESTION_SET: {
      return {
        ...state,
        questionSet: initialState.questionSet
      }
    }
    case actionTypes.SAVE_QUESTION_SET: {
      return {
        ...state,
        questionSet: { ...state.questionSet, ...action.questionSet }
      }
    }
    case actionTypes.FETCH_KNOWLEDGE_QUESTION_SETS_SUCCESS:
    case actionTypes.FETCH_KNOWLEDGE_QUESTION_SETS_NO_LOADER_SUCCESS: {
      questionSets = action.response
      return {
        ...state,
        questionSets: questionSets.map((questionSet, index) => {
          let displayStatus = questionSet.status
          if (!displayStatus && questionSet.answers) {
            displayStatus = 'published'
          } else if (!displayStatus) {
            displayStatus = 'unanswered'
          } else if (displayStatus === 'pending-create' || displayStatus === 'pending-update') {
            displayStatus = 'draft'
          } else if (displayStatus === 'pending-delete') {
            displayStatus = 'deletion'
          }
          return { ...questionSet, index: index, displayStatus: displayStatus }
        }),
        pendingQuestionSets: getPendingQuestionSets(questionSets)
      }
    }
    case actionTypes.FETCH_KNOWLEDGE_QUESTION_SET_SUCCESS: {
      return {
        ...state,
        questionSet: action.response
      }
    }
    case actionTypes.UPDATE_QUESTION_SETS_TO_PUBLISH: {
      return {
        ...state,
        questionSetsToPublish: action.questionSets,
        previousPath: action.previousPath
      }
    }
    case actionTypes.SAVE_DRAFT_QUESTION_SET_SUCCESS:
    case actionTypes.SAVE_PUBLISH_QUESTION_SET_SUCCESS: {
      return {
        ...state,
        createdQuestionSet: action.response
      }
    }
    case actionTypes.CLEAR_CREATED_QUESTION_SET: {
      return {
        ...state,
        createdQuestionSet: undefined
      }
    }
    default: {
      return state
    }
  }
}

const getPendingQuestionSets = (questionSets: QuestionSet[]) => {
  return sortBy(
    questionSets.filter(questionSet => {
      return questionSet.status && questionSet.status.toLowerCase().includes('pending')
    }),
    o => o.lastUpdatedDate
  ).reverse()
}
